// src/app/image-paths.ts

const BASE_PATH = 'assets/images/websitev2/';

export const IMAGE_NAMES = {
    OUR_VALUES_DASHBOARD: 'our-values-dashboard.png',
    PROFESSIONAL_SERVICES: 'professional-services.png',
    SHOP_BUTTON_ICON: 'shop-button-icon.png',
    VARROC_CONNECT_HARDWARE: 'varroc-connect-hardware.png',
    VARROC_CONNECT_LOGO: 'varroc-connect-logo.png',
    VARROC_CONNECT_WHITE_LOGO: 'varroc-connect-white-logo.png',
    VARROC_CONNECT_APP_DASHBOARD: 'varroc-connect-app-dashboard.png',
    WEBSITE_MAIN_BANNER: 'website-main-banner.png',
    VARROC_CONNECT_CLOUD: 'varroc-connect-cloud.png',
    WEBSITE_STATS: 'website-stats.png',
    FOOTER_PLAYSTORE: 'footer-playstore.png',
    FOOTER_APPSTORE: 'footer-appstore.png',
    FOOTER_SHOP: 'shop-button-footer.png',
    FOOTER_LINE: 'footer-line.png',
    SOLUTION_BFSI: 'bfsi-solution.png',
    SOLUTION_B2C: 'b2c-solution.png',
    SOLUTION_AUTOMOTIVE: 'automotive-solution.png',
    SOLUTION_TLS: 'tls-solution.png',
    STAR_ICON: 'star-icon.png',
    LIGHT_QUOTE: 'light-quote.png',
    DARK_QUOTE: 'dark-quote.png',
    CUSTOMER_1: 'customer-1.png',
    CUSTOMER_2: 'customer-2.png',
    CUSTOMER_3: 'customer-3.png',
    CUSTOMER_4: 'customer-4.png',
    CUSTOMER_5: 'customer-5.png',
    RATING_STAR: 'rating-stars.png',
    HIERARCHY_1: 'our-products/hierarchy-1.png',
    HIERARCHY_2: 'our-products/hierarchy-2.png',
    PRODUCT_BANNER: 'our-products/product-banner.png',
    OTA: 'our-products/ota.png',
    INSURANCE_CLOUD: 'our-products/vc-insurance-cloud.png',
    PLAY_STORE_BUTTON: 'our-products/play-store.png',
    APP_STORE_BUTTON: 'our-products/app-store.png',
    CLICK_ICON: 'our-products/click.png',
    VC_APP_BANNER: 'our-products/vc-apps-banner.png',
    VC_BLACKBOX: 'our-products/vc-blackbox.png',
    VC_SMARTPLUG: 'our-products/vc-smartplug.png',
    VC_TCU: 'our-products/vc-tcu.png',
    SCORE_0_5: 'our-products/score-0-5.png',
    SCORE_6_8: 'our-products/score-6-8.png',
    SCORE_9_10: 'our-products/score-9-10.png',
    ICON_OBD: 'info-icons/obd.png',
    ICON_SAFETY: 'info-icons/safety.png',
    ICON_ANALYTICS: 'info-icons/analytics.png',
    ICON_CAR: 'info-icons/car.png',
    ICON_FUEL: 'info-icons/fuel.png',
    ICON_GUAGE: 'info-icons/guage.png',
    ICON_REFRESH: 'info-icons/refresh.png',
    ICON_SETTING: 'info-icons/setting.png',
    ICON_SIGNAL: 'info-icons/signal.png',
    ICON_STEARING: 'info-icons/stearing.png',
    ICON_TRUCK: 'info-icons/truck.png',
    ICON_WATCH: 'info-icons/watch.png',
    ICON_ZOOM: 'info-icons/zoom.png',
    ICON_DATA_SEARCH: 'info-icons/data-search.png',
    ICON_GEOFENCE: 'info-icons/geofence.png',
    ICON_LOCATION_TRACK: 'info-icons/location-track.png',
    ICON_PARKING_HUB: 'info-icons/parking-hub.png',
    SOLUTION_AUTOMOTIVE_BANNER: 'our-solutions/automotive.png',
    SOLUTION_BFSI_BANNER: 'our-solutions/bfsi-solution.png',
    SOLUTION_TLS_BANNER: 'our-solutions/tls-solution.png',
    SOLUTION_BANNER: 'our-solutions/solutions-banner.png',
    SOLUTION_B2C_HORIZONTAL_BANNER: 'our-solutions/b2c-horizontal.png',
    SOLUTION_B2C_VERTICAL_BANNER: 'our-solutions/b2c-vertical.png',
    LEADERSHIP_BANNER: 'leadership/leadership-banner.png',
    CEO: 'leadership/ceo.png',
    CTO: 'leadership/cto.png',
    BM1: 'leadership/bm1.png',
    BM2: 'leadership/bm2.png',
    CHAIRMAN: 'leadership/chairman.png',
    CYBER_SECURITY: 'cyber-security-banner.png',
    T_AND_C_BANNER: 'tandc-banner.png',
    CONTACT_BANNER: 'contact/contact-banner.png',
    CONTACT_PHONE_ICON: 'contact/call.png',
    CONTACT_EMAIL_ICON: 'contact/email.png',
    CONTACT_MAP: 'contact/map.png',
};

export const IMAGES = {
    OUR_VALUES_DASHBOARD: BASE_PATH + IMAGE_NAMES.OUR_VALUES_DASHBOARD,
    PROFESSIONAL_SERVICES: BASE_PATH + IMAGE_NAMES.PROFESSIONAL_SERVICES,
    SHOP_BUTTON_ICON: BASE_PATH + IMAGE_NAMES.SHOP_BUTTON_ICON,
    VARROC_CONNECT_HARDWARE: BASE_PATH + IMAGE_NAMES.VARROC_CONNECT_HARDWARE,
    VARROC_CONNECT_LOGO: BASE_PATH + IMAGE_NAMES.VARROC_CONNECT_LOGO,
    VARROC_CONNECT_WHITE_LOGO: BASE_PATH + IMAGE_NAMES.VARROC_CONNECT_WHITE_LOGO,
    VARROC_CONNECT_APP_DASHBOARD: BASE_PATH + IMAGE_NAMES.VARROC_CONNECT_APP_DASHBOARD,
    WEBSITE_MAIN_BANNER: BASE_PATH + IMAGE_NAMES.WEBSITE_MAIN_BANNER,
    VARROC_CONNECT_CLOUD: BASE_PATH + IMAGE_NAMES.VARROC_CONNECT_CLOUD,
    WEBSITE_STATS: BASE_PATH + IMAGE_NAMES.WEBSITE_STATS,
    FOOTER_PLAYSTORE: BASE_PATH + IMAGE_NAMES.FOOTER_PLAYSTORE,
    FOOTER_APPSTORE: BASE_PATH + IMAGE_NAMES.FOOTER_APPSTORE,
    FOOTER_SHOP: BASE_PATH + IMAGE_NAMES.FOOTER_SHOP,
    FOOTER_LINE: BASE_PATH + IMAGE_NAMES.FOOTER_LINE,
    SOLUTION_BFSI: BASE_PATH + IMAGE_NAMES.SOLUTION_BFSI,
    SOLUTION_B2C: BASE_PATH + IMAGE_NAMES.SOLUTION_B2C,
    SOLUTION_AUTOMOTIVE: BASE_PATH + IMAGE_NAMES.SOLUTION_AUTOMOTIVE,
    SOLUTION_TLS: BASE_PATH + IMAGE_NAMES.SOLUTION_TLS,
    STAR_ICON: BASE_PATH + IMAGE_NAMES.STAR_ICON,
    LIGHT_QUOTE: BASE_PATH + IMAGE_NAMES.LIGHT_QUOTE,
    DARK_QUOTE: BASE_PATH + IMAGE_NAMES.DARK_QUOTE,
    CUSTOMER_1: BASE_PATH + IMAGE_NAMES.CUSTOMER_1,
    CUSTOMER_2: BASE_PATH + IMAGE_NAMES.CUSTOMER_2,
    CUSTOMER_3: BASE_PATH + IMAGE_NAMES.CUSTOMER_3,
    CUSTOMER_4: BASE_PATH + IMAGE_NAMES.CUSTOMER_4,
    CUSTOMER_5: BASE_PATH + IMAGE_NAMES.CUSTOMER_5,
    RATING_STAR: BASE_PATH + IMAGE_NAMES.RATING_STAR,
    HIERARCHY_1: BASE_PATH + IMAGE_NAMES.HIERARCHY_1,
    HIERARCHY_2: BASE_PATH + IMAGE_NAMES.HIERARCHY_2,
    PRODUCT_BANNER: BASE_PATH + IMAGE_NAMES.PRODUCT_BANNER,
    OTA: BASE_PATH + IMAGE_NAMES.OTA,
    INSURANCE_CLOUD: BASE_PATH + IMAGE_NAMES.INSURANCE_CLOUD,
    ICON_OBD: BASE_PATH + IMAGE_NAMES.ICON_OBD,
    ICON_ANALYTICS: BASE_PATH + IMAGE_NAMES.ICON_ANALYTICS,
    ICON_CAR: BASE_PATH + IMAGE_NAMES.ICON_CAR,
    ICON_FUEL: BASE_PATH + IMAGE_NAMES.ICON_FUEL,
    ICON_GUAGE: BASE_PATH + IMAGE_NAMES.ICON_GUAGE,
    ICON_REFRESH: BASE_PATH + IMAGE_NAMES.ICON_REFRESH,
    ICON_SETTING: BASE_PATH + IMAGE_NAMES.ICON_SETTING,
    ICON_SIGNAL: BASE_PATH + IMAGE_NAMES.ICON_SIGNAL,
    ICON_STEARING: BASE_PATH + IMAGE_NAMES.ICON_STEARING,
    ICON_TRUCK: BASE_PATH + IMAGE_NAMES.ICON_TRUCK,
    ICON_WATCH: BASE_PATH + IMAGE_NAMES.ICON_WATCH,
    ICON_ZOOM: BASE_PATH + IMAGE_NAMES.ICON_ZOOM,
    ICON_DATA_SEARCH: BASE_PATH + IMAGE_NAMES.ICON_DATA_SEARCH,
    ICON_GEOFENCE: BASE_PATH + IMAGE_NAMES.ICON_GEOFENCE,
    ICON_LOCATION_TRACK: BASE_PATH + IMAGE_NAMES.ICON_LOCATION_TRACK,
    ICON_SAFETY: BASE_PATH + IMAGE_NAMES.ICON_SAFETY,
    ICON_PARKING_HUB: BASE_PATH + IMAGE_NAMES.ICON_PARKING_HUB,
    PLAY_STORE_BUTTON: BASE_PATH + IMAGE_NAMES.PLAY_STORE_BUTTON,
    APP_STORE_BUTTON: BASE_PATH + IMAGE_NAMES.APP_STORE_BUTTON,
    CLICK_ICON: BASE_PATH + IMAGE_NAMES.CLICK_ICON,
    VC_APP_BANNER: BASE_PATH + IMAGE_NAMES.VC_APP_BANNER,
    VC_BLACKBOX: BASE_PATH + IMAGE_NAMES.VC_BLACKBOX,
    VC_SMARTPLUG: BASE_PATH + IMAGE_NAMES.VC_SMARTPLUG,
    VC_TCU: BASE_PATH + IMAGE_NAMES.VC_TCU,
    SOLUTION_AUTOMOTIVE_BANNER: BASE_PATH + IMAGE_NAMES.SOLUTION_AUTOMOTIVE_BANNER,
    SOLUTION_BFSI_BANNER: BASE_PATH + IMAGE_NAMES.SOLUTION_BFSI_BANNER,
    SOLUTION_TLS_BANNER: BASE_PATH + IMAGE_NAMES.SOLUTION_TLS_BANNER,
    SOLUTION_B2C_HORIZONTAL_BANNER: BASE_PATH + IMAGE_NAMES.SOLUTION_B2C_HORIZONTAL_BANNER,
    SOLUTION_B2C_VERTICAL_BANNER: BASE_PATH + IMAGE_NAMES.SOLUTION_B2C_VERTICAL_BANNER,
    SCORE_0_5: BASE_PATH + IMAGE_NAMES.SCORE_0_5,
    SCORE_6_8: BASE_PATH + IMAGE_NAMES.SCORE_6_8,
    SCORE_9_10: BASE_PATH + IMAGE_NAMES.SCORE_9_10,
    CEO: BASE_PATH + IMAGE_NAMES.CEO,
    CTO: BASE_PATH + IMAGE_NAMES.CTO,
    BM1: BASE_PATH + IMAGE_NAMES.BM1,
    BM2: BASE_PATH + IMAGE_NAMES.BM2,
    CHAIRMAN: BASE_PATH + IMAGE_NAMES.CHAIRMAN,
    LEADERSHIP_BANNER: BASE_PATH + IMAGE_NAMES.LEADERSHIP_BANNER,
    CYBER_SECURITY: BASE_PATH + IMAGE_NAMES.CYBER_SECURITY,
    T_AND_C_BANNER: BASE_PATH + IMAGE_NAMES.T_AND_C_BANNER,
    CONTACT_BANNER: BASE_PATH + IMAGE_NAMES.CONTACT_BANNER,
    CONTACT_PHONE_ICON: BASE_PATH + IMAGE_NAMES.CONTACT_PHONE_ICON,
    CONTACT_EMAIL_ICON: BASE_PATH + IMAGE_NAMES.CONTACT_EMAIL_ICON,
    CONTACT_MAP: BASE_PATH + IMAGE_NAMES.CONTACT_MAP,
    SOLUTION_BANNER: BASE_PATH + IMAGE_NAMES.SOLUTION_BANNER,
};

export const STACK_IMAGE_NAMES = {
    APPS: 'stack/apps.png',
    CLOUD: 'stack/cloud.png',
    COMMUNITY: 'stack/community.png',
    ECOSYSTEM: 'stack/ecosystem.png',
    HARDWARE: 'stack/hardware.png',
    SERVICES: 'stack/services.png',
};

export const STACK_IMAGES = {
    APPS: BASE_PATH + STACK_IMAGE_NAMES.APPS,
    CLOUD: BASE_PATH + STACK_IMAGE_NAMES.CLOUD,
    COMMUNITY: BASE_PATH + STACK_IMAGE_NAMES.COMMUNITY,
    ECOSYSTEM: BASE_PATH + STACK_IMAGE_NAMES.ECOSYSTEM,
    HARDWARE: BASE_PATH + STACK_IMAGE_NAMES.HARDWARE,
    SERVICES: BASE_PATH + STACK_IMAGE_NAMES.SERVICES,
}

export const NAV_HOVER = {
    AUTOMOTIVE: 'nav-hover/automotive.png',
    BFSI: 'nav-hover/bfsi.png',
    LEADERSHIP: 'nav-hover/leadership.png',
    VC_APP: 'nav-hover/vc-app.png',
    VC_HARDWARE: 'nav-hover/vc-hardware.png',
    B2C: 'nav-hover/b2c.png',
    CAREERS: 'nav-hover/careers.png',
    TLS: 'nav-hover/tls.png',
    VC_CLOUD: 'nav-hover/vc-cloud.png',
    VC_SCORE: 'nav-hover/vc-score.png',
};

export const NAV_HOVER_IMAGES = {
    AUTOMOTIVE: BASE_PATH + NAV_HOVER.AUTOMOTIVE,
    BFSI: BASE_PATH + NAV_HOVER.BFSI,
    LEADERSHIP: BASE_PATH + NAV_HOVER.LEADERSHIP,
    VC_APP: BASE_PATH + NAV_HOVER.VC_APP,
    VC_HARDWARE: BASE_PATH + NAV_HOVER.VC_HARDWARE,
    B2C: BASE_PATH + NAV_HOVER.B2C,
    CAREERS: BASE_PATH + NAV_HOVER.CAREERS,
    TLS: BASE_PATH + NAV_HOVER.TLS,
    VC_CLOUD: BASE_PATH + NAV_HOVER.VC_CLOUD,
    VC_SCORE: BASE_PATH + NAV_HOVER.VC_SCORE,
};

export const GRADIENT_ICONS = {
    BABELFISH: BASE_PATH + 'gradient-icons/babelfish.png',
    MILES: BASE_PATH + 'gradient-icons/miles.png',
    OASIS: BASE_PATH + 'gradient-icons/oasis.png',
    VC_SCORE: BASE_PATH + 'gradient-icons/vc-score.png',
    VEHICLE_APP_STORE: BASE_PATH + 'gradient-icons/in-vehicle-app-store.png',
};